__webpack_require__.p = "https://docs-website-fr.netlify.app/";